import React from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
  openNewTab?: boolean
}

const MenuItem: React.FC<Props> = ({
  to,
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
  openNewTab = false,
}) => {
  const {pathname} = useLocation()
  // Menü Yönetimi'nden dış bağlantı (https://…) da eklenebilir
  const isExternal = /^https?:\/\//i.test(to)

  const content = (
    <>
      {hasBullet && (
        <span className='menu-bullet'>
          <span className='bullet bullet-dot'></span>
        </span>
      )}

      {icon && (
        <span className='menu-icon'>
          <KTSVG path={icon} className='svg-icon-2' />
        </span>
      )}

      {fontIcon && (
        <span className='menu-icon'>
          <i className={clsx('bi fs-3', fontIcon)}></i>
        </span>
      )}

      <span className='menu-title'>{title}</span>

      {hasArrow && <span className='menu-arrow'></span>}
    </>
  )

  return (
    <div className='menu-item me-lg-1'>
      {isExternal ? (
        <a className='menu-link py-3' href={to} target='_blank' rel='noopener noreferrer'>
          {content}
        </a>
      ) : (
        <Link
          className={clsx('menu-link py-3', {
            active: checkIsActive(pathname, to),
          })}
          to={to}
          target={openNewTab ? '_blank' : undefined}
          rel={openNewTab ? 'noopener noreferrer' : undefined}
        >
          {content}
        </Link>
      )}
    </div>
  )
}

export {MenuItem}
